import type { ApiError, InviteRequestInput, InviteRequestResponse } from "@pokersports/shared";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "http://localhost:4000";

export async function submitInviteRequest(input: InviteRequestInput): Promise<InviteRequestResponse> {
  const response = await fetch(`${API_BASE_URL}/api/invite-requests`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(input)
  });

  const payload = (await response.json()) as InviteRequestResponse | ApiError;

  if (!response.ok || !payload.success) {
    const message = !payload.success ? payload.error.message : "Unknown API error";
    throw new Error(message);
  }

  return payload;
}

